import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store/Store'

type ReferralProgramState = {
  year: string
  currency: string
}

const referrerProgramSlice = createSlice({
  name: 'team',
  initialState: {
    year: new Date().getFullYear().toString(),
  } as ReferralProgramState,
  reducers: {
    setYear: (state: ReferralProgramState, action: PayloadAction<string>) => {
      state.year = action.payload
    },
    setCurrency: (state: ReferralProgramState, action: PayloadAction<string>) => {
      state.currency = action.payload
    },
  },
})

export const { setYear, setCurrency } = referrerProgramSlice.actions

export const selectReferrerProgramYear = (state: RootState) => state.root.referrerProgram.year
export const selectReferrerProgramCurrency = (state: RootState) =>
  state.root.referrerProgram.currency

export default referrerProgramSlice.reducer
